module.exports = function (element) {
    function mixBlock(el) {
        let resolution, catalog;

        let node = $(el);
        let link = node.find('.js-mix');
        let url = link.attr('href');

        let refresh = function () {
            $.post(url, {'catalog': catalog, 'resolution': resolution}, function (data) {
                $(".js-mix-cnt").text(data.result.total);

                for (let i = 0; i < data.result.items.length; i++) {
                    $(".js-mix-block a:eq(" + i + ")")
                        .html('<div><img src="' + data.result.items[i].img + '" width="130" height="82"></div>')
                        .attr('href', data.result.items[i].url)
                        .attr('title', data.result.items[i].tag);
                }
            }, "json");
        }

        node.find('.js-select-resolution').on({
            click: function () {
                resolution = $(this).data('resolution');
                refresh();

                return false;
            }
        });

        node.find('.js-select-catalog').on({
            click: function () {
                catalog = $(this).data('catalog');
                refresh();

                return false;
            }
        });

        node.on({
            click: function () {
                refresh();

                return false;
            }
        });
    }

    if (!element) {
        throw new Error('Element undefined');
    }

    mixBlock(element);
};